angular.module('core')
    .directive('money', function () {
        return {
            scope: {
                amount: '=',
                currency: '=',
                decimals: '<?'
            },
            replace: true,
            template: '<span><span ng-if="currency != null && currency !== \'PLN\'">{{amount | currency:currency:(decimals == null ? 2 : decimals)}}</span><span ng-if="currency == null || currency === \'PLN\'">{{amount | number:(decimals == null ? 2 : decimals)}}</span></span>'
        }
    })
